import React, { forwardRef } from "react";
import styled from "styled-components";

const Flex = forwardRef(({ children, flex, width, height, direction, alignItems, justifyContent, gap, ...props }, ref) => {
    return (
        <HVFlex
            $flex={flex}
            $height={height}
            $width={width}
            $direction={direction}
            $alignItems={alignItems}
            $justifyContent={justifyContent}
            $gap={gap}
            ref={ref}
            {...props}
        >
            {children}
        </HVFlex>
    );
});

const HVFlex = styled.div`
  flex: ${props => props.$flex};
  height: ${props => props.$height === "auto" ? "auto" : `${typeof props.$height === "string" ? props.$height : `${props.$height}px`}`};
  width: ${props => props.$width === "auto" ? "auto" : `${typeof props.$width === "string" ? props.$width : `${props.$width}px`}`};
  display: flex;
  flex-direction: ${props => props.$direction};
  align-items: ${props => props.$alignItems};
  justify-content: ${props => props.$justifyContent};
  gap: ${props => props.$gap}px;
`;

HVFlex.defaultProps = {
    $width: "auto",
    $height: "auto",
    $flex: "initial",
    $direction: "row",
    $alignItems: "center",
    $justifyContent: "flex-start",
    $gap: 5
}

export default Flex;